import type { FC, SVGProps } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export interface BotIconProps extends SVGProps<SVGSVGElement> {
  /** Size of the icon (width and height) */
  size?: number;
  /** Color of the icon */
  color?: string;
}

export const BotIcon: FC<BotIconProps> = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const fill = isDark ? '#333333' : 'white';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="3.5" width="1.5" height="8" rx="0.75" fill={fill} />
      <rect x="7.5" y="1.5" width="1.5" height="12" rx="0.75" fill={fill} />
      <rect x="11" y="1.5" width="1.5" height="12" rx="0.75" fill={fill} />
      <rect x="14.5" y="3.5" width="1.5" height="8" rx="0.75" fill={fill} />
      <path
        d="M3 13C5.30453 15.2639 11.3309 18.4333 17 13"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

// Backstage IconComponent compatible wrapper
export const BotIconComponent: FC<SvgIconProps> = ({
  fontSize = 'medium',
  color = 'inherit',
  titleAccess,
  htmlColor,
  inheritViewBox,
  shapeRendering,
  ...props
}) => {
  // Map fontSize to size
  const sizeMap = {
    small: 20,
    medium: 24,
    large: 35,
    inherit: 24,
  };

  const size = typeof fontSize === 'string' ? sizeMap[fontSize] || 24 : 24;

  return (
    <BotIcon
      size={size}
      color={color === 'inherit' ? '#B5B5B5' : (color as string)}
      {...props}
    />
  );
};
